import React, { useState, useRef } from 'react';
import './hidescrollbarx.css';

function Member() {
    const [members, setmembers] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 10]);
    const scrollContainerRef = useRef(null);

    const scrollLeft = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({
                left: -300,
                behavior: 'smooth',
            });
        }
    };

    const scrollRight = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({
                left: 300, 
                behavior: 'smooth',
            });
        }
    };
    
    return (
        <div className='flex flex-row'>
            <div className='w-1/12 flex justify-center items-center' >
                <i className="fa-solid fa-chevron-left fa-xl" onClick={scrollLeft} style={{cursor:'pointer'}} title='Scroll Left'></i>
            </div>

            <div className="flex flex-col m-auto p-auto w-10/12" style={{ fontFamily: "Ropa Sans" }}>
                <h1 className="flex py-5 font-bold text-4xl  lg:justify-start justify-center" style={{color:'#001F33'}}>
                    Members
                </h1>
                <div className="flex overflow-x-scroll pb-10 hide-scroll-bar" ref={scrollContainerRef}>
                    <div className="flex flex-nowrap mt-10">
                        {members.map(membersvalues => (
                            <div className="inline-block me-20" key={membersvalues}>
                                <div className="w-64 h-96 max-w-xs overflow-hidden -lg -md hover:shadow-xl transition-shadow duration-300 ease-in-out">
                                    <img src="https://ministersandgovernors.com/wp-content/uploads/2020/03/Pinarayi-Vijayan.jpg" title={`Member ${membersvalues}`} style={{ width: '100%', height: '90%' ,}} alt={`Member${membersvalues}`} />
                                    <div className='flex flex-row justify-between'>
                                        <h2 className='ms-2 mt-1' style={{color:'#001F33'}}>Shri: Pinarayi Vijayan</h2>
                                        {/* <h5 className='me-2 text-xs items-center mt-2 text-slate-500'>jan 21 - 2024</h5> */}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className='w-1/12 flex justify-center items-center' >
            <i class="fa-solid fa-chevron-right fa-xl " title='Scroll Right' onClick={scrollRight} style={{cursor:'pointer'}}></i>
            </div>

        </div>
    );
}

export default Member;
